import { call, put, takeLeading } from 'redux-saga/effects';
import ontologyMaster from '../api/ontologyMaster';
import { ontologyMasterActions } from '../reducers/ontology-master';

function* getOntologyList({ payload }: any): any {
  const res = yield call(ontologyMaster.fetchOntologyList, payload);
  if (res.status === 'success') {
    yield put(ontologyMasterActions.getOntologyResponse(res));
  } else {
    yield put(ontologyMasterActions.ontologyResponseFailed(res?.code));
  }
}

function* saveOntologyList({ payload }: any): any {
  const res = yield call(ontologyMaster.saveOntology, payload);
  if (res.status === 'success') {
    yield put(ontologyMasterActions.saveOntologyResponse(res?.code));
  } else {
    yield put(ontologyMasterActions.saveOntologyFailed(res?.code));
  }
}

function* updateLevelMaster({ payload }: any): any {
  const res = yield call(ontologyMaster.updateLevelMaster, payload);
  if (res.status === 'success') {
    yield put(ontologyMasterActions.updateLevelmasterBulkResponse(res?.code));
  } else {
    yield put(ontologyMasterActions.updateLevelmasterBulkFailed(res?.code));
  }
}

function* addOntologyMaster({ payload }: any): any {
  const res = yield call(ontologyMaster.addOntologyMaster, payload);
  if (res.status === 'success') {
    yield put(ontologyMasterActions.addOntologyMasterResponse(res));
  } else {
    yield put(ontologyMasterActions.addOntologyMasterFailed(res?.code));
  }
}

function* updateOntologyMaster({ payload }: any): any {
  const res = yield call(ontologyMaster.updateOntologyMaster, payload);
  if (res.status === 'success') {
    yield put(ontologyMasterActions.updateOntologyMasterResponse(res));
  } else {
    yield put(ontologyMasterActions.updateOntologyMasterFailed(res?.code));
  }
}

function* getOntologyMgmntList({ payload }: any): any {
  const res = yield call(ontologyMaster.getAllOntologies, payload);
  if (res.status === 'success') {
    yield put(ontologyMasterActions.getOntologyMgmntResponse(res));
  } else {
    yield put(ontologyMasterActions.ontologyMgmntResponseFailed(res?.code));
  }
}

function* getFactoriesOntologies(): any {
  const res = yield call(ontologyMaster.getFactoriesOntologies);
  if (res.status === 'success') {
    yield put(ontologyMasterActions.getFactoriesOntologiesResponse(res));
  } else {
    yield put(ontologyMasterActions.getFactoriesOntologiesFailed(res?.code));
  }
}

function* OntologyMasterSaga() {
  yield takeLeading('ontologyMaster/getOntologyList', getOntologyList);
  yield takeLeading('ontologyMaster/saveOntologyData', saveOntologyList);
  yield takeLeading('ontologyMaster/addOntologyMasterReq', addOntologyMaster);
  yield takeLeading('ontologyMaster/updateOntologyMasterReq', updateOntologyMaster);
  yield takeLeading('ontologyMaster/getOntologyMgmntList', getOntologyMgmntList);
  yield takeLeading('ontologyMaster/updateLevelmasterBulk', updateLevelMaster);
  yield takeLeading('ontologyMaster/getFactoriesOntologiesRequest', getFactoriesOntologies);
}

export default OntologyMasterSaga;
